/**
 * Merchant app entry point.
 *
 * Rendered through `react-dom/client` for the same reason as the customer app:
 * `AppRegistry.runApplication` bridges native lifecycle events this web build
 * does not use. The Tailwind stylesheet is imported first so the token variables
 * exist before the first React Native Web style is resolved.
 */

import { createRoot } from 'react-dom/client';

import { App } from './App';
import '../global.css';
import './styles.css';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Missing #root element in index.html');
}

createRoot(container).render(<App />);
